import { useCallback, useMemo, useState } from 'react';
import './control-boards.scss';
import DataGrid, { Selection, Column, Scrolling, LoadPanel as LoadPanelDg } from 'devextreme-react/data-grid';
import { Button, LoadPanel, TextBox, Tooltip } from 'devextreme-react';
import { ToolbarSimple } from '../../components';
import { ScrollView } from 'devextreme-react';
import { microscopieBlue } from '../../images/icons';
import { BoardViewer } from '../../components/utils/board-viewer/BoardViewer';
import { useControlBoards } from '../../hooks/useControlBoards';

const Index = () => {
  const { boards, loading, selectedBoard, selectBoard } = useControlBoards();
  const [sidebarVisible, setSidebarVisible] = useState<boolean>(true);
  const [searchText, setSearchText] = useState<string>('');

  // Filtrar tableros por texto de búsqueda
  const filteredBoards = useMemo(() => {
    if (!searchText || searchText.trim() === '') {
      return boards;
    }
    const searchLower = searchText.toLowerCase().trim();
    return boards.filter((b: any) => (b.Rp_Nombre || '').toLowerCase().includes(searchLower));
  }, [boards, searchText]);

  const handleClicSelection = useCallback(
    (e) => {
      const row = e.selectedRowsData && e.selectedRowsData[0];
      if (!row) return;
      selectBoard(row);
    },
    [selectBoard]
  );

  const toggleSidebar = useCallback(() => {
    setSidebarVisible((prev) => !prev);
  }, []);

  const getReportIcon = (name?: string) => {
    const n = (name || '').toLowerCase();
    if (n.includes('factura')) return 'money';
    if (n.includes('venta')) return 'cart';
    if (n.includes('estadist') || n.includes('total') || n.includes('estad')) return 'chart';
    if (n.includes('examen') || n.includes('exámenes') || n.includes('examenes')) return 'microscopie';
    if (n.includes('informe') || n.includes('remit')) return 'doc';
    if (n.includes('vendedor') || n.includes('vended')) return 'group';
    if (n.includes('médico') || n.includes('medico') || n.includes('doctor')) return 'user';
    return 'doc';
  };

  const renderReportCell = (cellData: any) => {
    const name = cellData.data?.Rp_Nombre || '';
    const icon = getReportIcon(name);
    const cellId = `report-cell-${cellData.data?.Rp_Id || cellData.rowIndex}`;
    return (
      <>
        <div className='report-cell' id={cellId}>
          <div className='report-cell-icon'>{icon === 'microscopie' ? <img src={microscopieBlue} alt='microscopio' className='report-svg-icon' /> : <i className={`dx-icon dx-icon-${icon}`}></i>}</div>
          <div className='report-cell-name'>{name}</div>
        </div>
        <Tooltip target={`#${cellId}`} showEvent='mouseenter' hideEvent='mouseleave' position='right'>
          {name}
        </Tooltip>
      </>
    );
  };

  const handleSelectReportCollapsed = useCallback(
    (report: any) => {
      if (!report) return;
      selectBoard(report);
    },
    [selectBoard]
  );

  return (
    <div className='control-boards-page'>
      <ScrollView className='view-wrapper-scroll'>
        <ToolbarSimple title='Tableros de control'>
          <div className='boards-container'>
            {sidebarVisible ? (
              <div className='boards-sidebar'>
                <div className='sidebar-toggle-header'>
                  <Button icon='chevronleft' onClick={toggleSidebar} stylingMode='text' hint='Ocultar panel' />
                </div>
                <div className='sidebar-search'>
                  <TextBox placeholder='Buscar tablero...' value={searchText} onValueChanged={(e) => setSearchText(e.value || '')} mode='search' stylingMode='outlined' width='100%' />
                </div>
                <LoadPanel visible={loading} position={{ of: '.boards-sidebar' }} />
                <DataGrid height={'calc(100vh - 310px)'} className='boards-grid' dataSource={filteredBoards} keyExpr={'Rp_Id'} rowAlternationEnabled={false} hoverStateEnabled={true} onSelectionChanged={handleClicSelection} selectedRowKeys={selectedBoard?.Rp_Id ? [selectedBoard.Rp_Id] : []}>
                  <LoadPanelDg enabled={true} />
                  <Scrolling mode='virtual' />
                  <Selection mode='single' />
                  <Column dataField='Rp_Nombre' caption='TABLERO' cellRender={renderReportCell} />
                </DataGrid>
              </div>
            ) : (
              <div className='boards-sidebar-collapsed' role='navigation'>
                <div className='collapsed-inner'>
                  <div className='collapsed-toggle-top'>
                    <Button icon='menu' onClick={toggleSidebar} stylingMode='text' hint='Mostrar panel' />
                  </div>

                  <div className='collapsed-reports'>
                    {boards && boards.length > 0 ? (
                      boards.map((rp: any, idx: number) => (
                        <>
                          <button key={idx} type='button' id={`collapsed-board-${rp.Rp_Id}`} className={`collapsed-report-item ${selectedBoard?.Rp_Id && selectedBoard.Rp_Id === rp.Rp_Id ? 'selected' : ''}`} onClick={() => handleSelectReportCollapsed(rp)}>
                            {getReportIcon(rp.Rp_Nombre) === 'microscopie' ? <img src={microscopieBlue} alt='microscopio' /> : <i className={`dx-icon dx-icon-${getReportIcon(rp.Rp_Nombre)}`}></i>}
                          </button>
                          <Tooltip target={`#collapsed-board-${rp.Rp_Id}`} showEvent='mouseenter' hideEvent='mouseleave' position='right'>
                            {rp.Rp_Nombre}
                          </Tooltip>
                        </>
                      ))
                    ) : (
                      <div className='collapsed-empty'>No hay tableros</div>
                    )}
                  </div>
                </div>
              </div>
            )}

            <div className='boards-content'>
              <BoardViewer board={selectedBoard} height='calc(100vh - 200px)' />
            </div>
          </div>
        </ToolbarSimple>
      </ScrollView>
    </div>
  );
};

export default Index;
